var map = {
	"./logo-bai-company-dark-color.svg": [
		"f0cc",
		"chunk-2d22bf60"
	],
	"./logo-bai-company-light-color.svg": [
		"58bc"
	],
	"./logo-bai-particular-dark-color.svg": [
		"d855",
		"chunk-2d21eeea"
	],
	"./logo-bai-particular-light-color.svg": [
		"bccc"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9683";
module.exports = webpackAsyncContext;